<template>
    <v-text-field
      ref="control"
      class="dynamic-input-control"
      suffix="%"
      :dense="dense"
      hide-details
      :readonly="readonly"
      v-model="stringValue"
      outlined
      @focusout="lostFocus"
      @change="setDirty(true)"
      :disabled="disabled"
      label="Zisk"
      v-bind:class="{
        'dynamic-input-control':true,
        'hide-error-icon': true,
        dense: dense,
        'no-label': true,
        'text-right': textRight,
        'hide-label': hideLabel,
      }"
      :error-messages="error"
    >
    </v-text-field>
  </template>

  <script>
  export default {
    props: {
      value: Number,
      decimalPlaces: {
        type: Number,
        default: 2,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      format: {
        type: Boolean,
        default: true,
      },
      zakladZisk:{
        type: Number,
        default: 0
      },
      readonly:{
        type: Boolean,
        default: false
      },
      tolerancia:{
        type: Number,
        default: 0
      },
      dense:{
        type: Boolean,
        default: true
      },
      textRight:{
        type: Boolean,
        default: true
      },
      hideLabel:{
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        stringValue: this.parseValue(this.value),
        error: "",
      };
    },
    mounted() {
      this.$watch(
        () => {
          return this.$refs.control.lazyValue;
        },
        () => {
          var number_regex = /^[+-]?[0-9]+([.][0-9]+)?$/;
          if (!number_regex.test(this.$refs.control.lazyValue)) {
                // Odstranenie vsetkych znakov okrem cisel, bodky a ciarky
                this.$refs.control.lazyValue = this.$refs.control.lazyValue.replace(/[^\d.,]+/g, '')
          }
        }
      );
  },
    watch: {
      value(val) {
        if (this.stringValue != this.parseValue(val)) {
          this.stringValue = this.parseValue(this.value).replace(",",'.');
          this.checkValue(this.stringValue);
        }
      },
    },
    methods: {
      parseValue(val) {
        if (val || val === 0) {
          if (this.format) {
            return new Intl.NumberFormat('sk-SK', {
            minimumFractionDigits: this.decimalPlaces,
          }).format(val);
          } else {
            return val + '';
          }
        } else {
          return null;
        }
      },
      checkValue(val) {
        if (val != null && val != '') {
            var number_regex = /^[+-]?[0-9]+([.,][0-9]+)?$/;
            val = val.replace(/\s+/g, '');
            if (!number_regex.test(val)) {
                return this.$emit('error', this.error = "Nesprávny formát");
                
            }
            if((this.zakladZisk - this.tolerancia) > parseFloat(Number(val).toFixed(this.decimalPlaces))){
              return this.$emit('error', this.error = "Zisk nemôže byť menší ako základný zisk.");
            }
          }else{
            return this.$emit('error',this.error = "Povinné pole");
          }
          return this.error = "";
      },
      lostFocus() {
          this.stringValue = this.stringValue.replace(",",'.');
          this.checkValue(this.stringValue)
          if(this.error == ""){
            if (this.stringValue.replace(/\s/g, '').replace('.', ',') != this.parseValue(this.value).replace(/\s/g, '').replace('.', ',')) {
              if(this.stringValue) {
                this.$emit('input', this.stringValue);
              }else{
                  this.$emit('input', null);
              }
            }
          }
        
      },
      getValue() {
        if (!this.stringValue) return null;
        let str = this.stringValue.replace(/\s/g, '').replace(',', '.');
        return parseFloat(Number(str).toFixed(this.decimalPlaces));
      },
      setValue(val) {
        this.stringValue = val;
      },
      setDirty(val){
        console.log('variant zisk dirty', val)
      },
    },
    
  };
  </script>
  